import { ArrowRight } from 'lucide-react';

interface BridgeSectionProps {
  onStartFree?: () => void;
}

export function BridgeSection({ onStartFree }: BridgeSectionProps) {
  return (
    <section className="py-16 bg-slate-900">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <p className="text-lg sm:text-xl text-slate-300 leading-relaxed mb-4">
          Most goals fail not because they're unrealistic - but because life gets in the way.
        </p>
        <p className="text-lg sm:text-xl text-white font-medium mb-4">
          VZMO helps you stay grounded in progress, not perfection.
        </p>
        <p className="text-base text-slate-400 mb-8">
          No guilt. No shame. Just forward motion.
        </p>
        {onStartFree && (
          <button
            onClick={onStartFree}
            className="group inline-flex items-center justify-center px-6 py-3 bg-white text-slate-900 font-semibold rounded-full hover:bg-slate-100 transition-all duration-200"
          >
            Get started free
            <ArrowRight className="ml-2 h-4 w-4 group-hover:translate-x-1 transition-transform duration-200" />
          </button>
        )}
      </div>
    </section>
  );
}
